module.exports = __webpack_public_path__ + "img/arcux.9cafb7e4.svg";